import React from 'react';

const Footer = () => {
    return (
        /* This is footer section */
        <div className="bg-dark p-5 mt-4 text-center text-white">
            <p className="mt-5">Copyright &copy; 2021 Saiful Islam Shanto. All Rights Reserved.</p>
        </div>
    );
};

export default Footer;